interface Props {
	theme: {
		contentType: 'theme';
		name: string;
		properties: {
			colorHeaderBackground: string;
			colorHeaderText: string;
			colorFooterBackground: string;
			colorFooterText: string;
			colorHeroBackground: string;
			colorHeroText: string;
			colorHeadline: string;
			colorBodyText: string;
			colorBodyBackground: string;
			colorCta: string;
			headingFont: string;
			bodyFont: string;
		};
	}[];
}

export const mapSiteTheme = ({ theme }: Props): Content.ThemeSettings => {
	try {
		return {
			documentType: theme[0].contentType,
			content: { ...theme[0].properties },
		};
	} catch (e) {
		throw new Error(`Could not map Site Theme \nCause: ${e}`, e);
	}
};
